import { gql } from "graphql-tag";
import ListBookType from "types/ListBookType";

export const markAsOwned = gql`
  mutation EditionOwned($id: Int!) {
    ownership: edition_owned(id: $id) {
      id
      listBook: list_book {
        ...ListBookFragment
      }
    }
  }
`;

export type MarkAsOwnedType = {
  ownership: {
    id: number;
    listBook: ListBookType;
  };
}